import { useIsMobileApp } from './useIsMobileApp.ts';
import { useTwaPushNotifications } from './useTwaPushNotifications.ts';

export const useCheckForMobilePushNotifications = () => {
  const { isIosApp, isMobileApp, isTwa, postMessage } = useIsMobileApp();
  const { enable: enableTwaPushNotifications } = useTwaPushNotifications();
  if (isTwa) {
    return () => {
      enableTwaPushNotifications();
    };
  }
  if (!isMobileApp) {
    return () => {};
  }
  if (isIosApp) {
    return () => {
      // oxlint-disable-next-line sorare/no-window-location
      window.location.replace('sorare://enable-push-notifications');
    };
  }
  return () => {
    postMessage('enablePushNotifications');
  };
};
